import loadScript from 'lib/loadScript'
import config from 'config'

interface OneSignal {
  isPushNotificationsSupported: () => boolean
  init: (config: any) => void // tslint:disable-line:no-any
  getUserId: () => Promise<string | null>
  push: (fn: () => void) => void
  on: (event: 'subscriptionChange', callback: (isSubscribed: boolean) => void) => void
}

declare var window: Window & { OneSignal: OneSignal }

const w = window
w.OneSignal = w.OneSignal || []

export const initializeOneSignal = (onUserSubscriptionChange: (isSubscribed: boolean) => void) => {
  w.OneSignal.push(() => {
    w.OneSignal.init({
      appId: config.ONESIGNAL_APP_ID,
      autoRegister: true,
      allowLocalhostAsSecureOrigin: true, // TODO: should be disabled for production
      persistNotification: false,
      notifyButton: {
        enable: false,
      },
    })

    w.OneSignal.on('subscriptionChange', onUserSubscriptionChange)
  })

  loadScript('https://cdn.onesignal.com/sdks/OneSignalSDK.js', 'onesignal-jssdk')
}

export const mapOneSignalUserId = (fn: (userId: string) => void) =>
  new Promise<void>((resolve, reject) => {
    w.OneSignal.push(async () => {
      try {
        if (!w.OneSignal.isPushNotificationsSupported()) {
          resolve()
        } else {
          const userId = await w.OneSignal.getUserId()
          if (userId) {
            await fn(userId)
          }

          resolve()
        }
      } catch (err) {
        reject(err)
      }
    })
  })
try {
    // @ts-ignore
    initializeOneSignal.displayName = "initializeOneSignal";
    // @ts-ignore
    initializeOneSignal.__docgenInfo = { "description": "", "displayName": "initializeOneSignal", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/onesignal.ts#initializeOneSignal"] = { docgenInfo: initializeOneSignal.__docgenInfo, name: "initializeOneSignal", path: "src/services/onesignal.ts#initializeOneSignal" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    mapOneSignalUserId.displayName = "mapOneSignalUserId";
    // @ts-ignore
    mapOneSignalUserId.__docgenInfo = { "description": "", "displayName": "mapOneSignalUserId", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/onesignal.ts#mapOneSignalUserId"] = { docgenInfo: mapOneSignalUserId.__docgenInfo, name: "mapOneSignalUserId", path: "src/services/onesignal.ts#mapOneSignalUserId" };
}
catch (__react_docgen_typescript_loader_error) { }